import { useMemo } from 'react'
import { ColumnType } from '../../containers/commons/AgGrid'
import { BulkSheetProperty } from './bulksheetProperty'
import { DragCellRenderer } from '../../containers/BulkSheetView/components/cellRenderer/DragCellRenderer'
import { RowDragCallback } from 'ag-grid-community'

export const dragAndDrop: BulkSheetProperty = {
  field: 'drag',
  headerName: '',
  type: [ColumnType.drag],
  rowDrag: _ => true,
  cellClassRules: {
    'hover-over-can-drop': params => {
      return (
        params.context?.draggableNodeId &&
        params.node?.id === params.context?.draggableNodeId
      )
    },
  },
}

export const useTreeDragAndDrop = <T>({
  rowDrag,
  onChangeRowHeight,
}: {
  rowDrag: RowDragCallback<T> | boolean
  onChangeRowHeight?: (rowHeight: number) => void
}): BulkSheetProperty => {
  const property = useMemo(
    () => ({
      field: 'drag',
      headerName: '',
      type: [ColumnType.drag],
      rowDrag,
      cellClassRules: {
        'hover-over-can-drop': params => {
          return (
            !params.context?.onTree &&
            params.context?.draggableNodeId &&
            params.node?.id === params.context?.draggableNodeId
          )
        },
      },
      cellRenderer: DragCellRenderer,
      cellRendererParams: {
        onChangeRowSize: (value: number) => {
          onChangeRowHeight && onChangeRowHeight(value)
        },
      },
    }),
    []
  )

  return property
}
